import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { useLocation, Link, useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import Loader from "react-js-loader";
import Swal from "sweetalert2";
import admindata from "../../components/admindata";
import { DateObject } from "react-multi-date-picker";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { apiRequest } from "../../apiServices/allApi";

import { BiEditAlt } from "react-icons/bi";
const $ = require("jquery");
$.Datatable = require("datatables.net");

export default function View(props) {
  const history =useHistory()
  const access_token = localStorage.getItem("token");
  const [user1, setUser1] = useState();

  // const getUser1 = () => {
  //   const headers = {
  //     Authorization: `Bearer ${access_token}`,
  //   };
  //   axios
  //     .get("https://api.ludo51.com/admin/me_data", { headers })
  //     .then((res) => {
  //       setUser1(res.data);
  //       // toast("Login Success")
  //       console.log(res.data);
  //     })
  //     // console.log("first")
  //     .catch((e) => {
  //       if (e.response.status == 401) {
  //         localStorage.removeItem("token");
  //         history.push("/adminlogin")
  //       }
  //     });
  // };

  const getUser1 = async () => {
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
  try {
    const res = await apiRequest( "admin/me_data","GET",null,headers)
    setUser1(res.data);
        // toast("Login Success")
        console.log(res);
  } catch (e) {
    if (e.response.status == 401) {
      localStorage.removeItem("token");
      history.push("/adminlogin")
    }
  } finally {
    // setLoading(false)
  }
}


  useEffect(() => {
    getUser1();
  }, []);

  const [loading, setLoading] = useState(false);
  const navigate = useHistory();
  const location = useLocation();
  const path = location.pathname.split("/")[3];
  const [user, setUser] = useState();
  const [item, setVerify] = useState();
  const [challenge, setchallenge] = useState();
  const [txn, setTxn] = useState();
  const [txnwith, setTxnwith] = useState();
  const [referral, setReferral] = useState();
  const [bonus, setBonus] = useState();
  const [penalty, setPenalty] = useState();
  const [kyc, setKyc] = useState();
  const [merged, setMerged] = useState([]);
  let [mismatchValue, setmismatchValue] = useState(0);
  let [HoldBalance, setHoldBalance] = useState(0);
  const [referCount, setRefercount] = useState([]);

  const [values, setValues] = useState([
    new DateObject().subtract(4, "days"),
    new DateObject().add(4, "days"),
  ]);

  //use for pagination..
  let [limit, setLimit] = useState(20);

  const setpageLimit = (event) => {
    let key = event.target.value;
    setLimit(key);
  };
  const [pageNumber, setPageNumber] = useState(0);
  const [numberOfPages, setNumberOfPages] = useState(0);

  //user for searching..
  const [searchList, setSearchList] = useState(0);
  const [searchType, setSearchType] = useState(0);
  const [findByStatus, setFindByStatus] = useState(0);

  //   searching handler
  const searchHandler = (event) => {
    let key = event.target.value;

    setSearchList(key);
  };
  //   search by status handler
  const searchByStatus = (event) => {
    let key = event.target.value;
    setFindByStatus(key);
  };

  //react paginate..
  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    // setPageNumber(currentPage);
    // scroll to the top
    //window.scrollTo(0, 0)
  };

  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  // console.log(path)
  const getUser = async() => {
    setLoading(true);
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // axios
    //   .get(baseUrl + `admin/get_user_data/${path}`, { headers })
    //   .then((res) => {
    //     setLoading(false);
    //     console.log(res.data);
    //     setUser(res.data);
    //     Allrefer(res.data.referral_code);
    //     setmismatchValue(
    //       res.data.Wallet_balance -
    //         (res.data.wonAmount -
    //           res.data.loseAmount +
    //           res.data.totalDeposit +
    //           res.data.referral_earning +
    //           res.data.totalBonus -
    //           (res.data.totalWithdrawl +
    //             res.data.referral_wallet +
    //             res.data.withdraw_holdbalance +
    //             res.data.hold_balance +
    //             res.data.totalPenalty))
    //     );
    //     setHoldBalance(res.data.hold_balance);
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setLoading(false);
    //   });


      try {
        const res =await apiRequest(   `admin/get_user_data/${path}`,"GET",null,headers);
        setLoading(false);
        console.log(res.data);
        setUser(res.data);
        Allrefer(res.data.referral_code);
        setmismatchValue(
          res.data.Wallet_balance -
            (res.data.wonAmount -
              res.data.loseAmount +
              res.data.totalDeposit +
              res.data.referral_earning +
              res.data.totalBonus -
              (res.data.totalWithdrawl +
                res.data.referral_wallet +
                res.data.withdraw_holdbalance +
                res.data.hold_balance +
                res.data.totalPenalty))
        );
        setHoldBalance(res.data.hold_balance);
        
      } catch (error) {
        // console.log(e);
        setLoading(false);
      } finally {
        // setLoading(false)
      }


  };

  const Allrefer = async (id) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // await axios
    //   .get(baseUrl + `admin/referral_code/${id}`, { headers })
    //   .then((res) => {
    //     setRefercount(res.data);
    //     console.log(res.data);
    //     setLoading(false);
    //   });

      try {
        const res =await apiRequest(  `admin/referral_code/${id}`,"GET",null,headers);
        setRefercount(res.data);
        console.log(res.data);
        setLoading(false);
        
      } catch (error) {
        // console.log(e);
        setLoading(false);
      } finally {
        // setLoading(false)
      }


  };

  const Allchallenge = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // axios
    //   .get(
    //     baseUrl +
    //       // `get_challange/user/${path}/?page=${pageNumber}&_limit=${limit}`,
    //       `get_challange/user/${path}`,
    //     { headers }
    //   )
    //   .then((res) => {
    //     setLoading(false);
    //     setTxn(undefined);
    //     setTxnwith(undefined);
    //     setReferral(undefined);
    //     setBonus(undefined);
    //     setPenalty(undefined);
    //     setKyc(undefined);
    //     setMerged(undefined);
    //     setchallenge(res.data);
    //     // setNumberOfPages(res.data.totalPages);
    //     $("table").dataTable();
    //     // console.log(path)
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setLoading(false);
    //   });

      try {
        const res =await apiRequest(  `get_challange/user/${path}`,"GET",null,headers);
        setLoading(false);
        setTxn(undefined);
        setTxnwith(undefined);
        setReferral(undefined);
        setBonus(undefined);
        setPenalty(undefined);
        setKyc(undefined);
        setMerged(undefined);
        setchallenge(res.data);
        // setNumberOfPages(res.data.totalPages);
        $("table").dataTable();
        // console.log(path)
      } catch (error) {
        // console.log(e);
        setLoading(false);
      } finally {
        // setLoading(false)
      }

  };

  const transactionHis = async() => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // axios
    //   .get(baseUrl + `admin/txn_history_admin/user/${path}`, { headers })
    //   .then((res) => {
    //     setLoading(false);
    //     setchallenge(undefined);
    //     setReferral(undefined);
    //     setBonus(undefined);
    //     setPenalty(undefined);
    //     setKyc(undefined);
    //     setTxnwith(undefined);
    //     setMerged(undefined);
    //     setTxn(res.data);
    //     $("table").dataTable();
    //   })
    //   .catch((e) => {
    //     setLoading(false);
    //     console.log(e);
    //   });

      try {
        const res =await apiRequest( `admin/txn_history_admin/user/${path}`,"GET",null,headers);
        setLoading(false);
        setchallenge(undefined);
        setReferral(undefined);
        setBonus(undefined);
        setPenalty(undefined);
        setKyc(undefined);
        setTxnwith(undefined);
        setMerged(undefined);
        setTxn(res.data);
        $("table").dataTable()
    
      } catch (error) {
        // console.log(e);
        setLoading(false);
      } finally {
        // setLoading(false)
      }

  };
  const withdrawalHis = async() => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // axios
    //   .get(baseUrl + `admin/txnwith_history_user/admin/${path}`, { headers })
    //   .then((res) => {
    //     setLoading(false);
    //     setTxn(undefined);
    //     setchallenge(undefined);
    //     setReferral(undefined);
    //     setBonus(undefined);
    //     setPenalty(undefined);
    //     setKyc(undefined);
    //     setMerged(undefined);
    //     setTxnwith(res.data);
    //     $("table").dataTable();
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setLoading(false);
    //   });

      try {
        const res =await apiRequest( `admin/txnwith_history_user/admin/${path}`,"GET",null,headers);
        setLoading(false);
        setTxn(undefined);
        setchallenge(undefined);
        setReferral(undefined);
        setBonus(undefined);
        setPenalty(undefined);
        setKyc(undefined);
        setMerged(undefined);
        setTxnwith(res.data);
        $("table").dataTable();
    
      } catch (error) {
        // console.log(e);
        setLoading(false);
      } finally {
        // setLoading(false)
      }


  };

  const dateFormat = (e) => {
    const date = new Date(e);
    const newDate = date.toLocaleString("default", {
      month: "long",
      day: "numeric",
      hour: "numeric",
      hour24: true,
      minute: "numeric",
    });
    return newDate;
  };

  const referralHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // await axios
    //   .get(baseUrl + `admin/referral_admin_history/code/winn/${user.referral_code}`, { headers })
    //   .then((res) => {
    //     setLoading(false);
    //     setchallenge(undefined);
    //     setTxn(undefined);
    //     setTxnwith(undefined);
    //     setKyc(undefined);
    //     setMerged(undefined);
    //     setBonus(undefined);
    //     setPenalty(undefined);
    //     setReferral(res.data);
    //     // console.log(res.data)
    //     $("table").dataTable();
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setLoading(false);
    //   });
      try {
        const res =await apiRequest( `admin/referral_admin_history/code/winn/${user.referral_code}`,"GET",null,headers);
        setLoading(false);
        setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);
        setKyc(undefined);
        setMerged(undefined);
        setBonus(undefined);
        setPenalty(undefined);
        setReferral(res.data);
        // console.log(res.data)
        $("table").dataTable();
    
      } catch (error) {
        // console.log(e);
        setLoading(false);
      } finally {
        // setLoading(false)
      }


  };
  const bonusHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // await axios
    //   .get(baseUrl + `admin/bonus_history_admin/user/${user.id}`, { headers })
    //   .then((res) => {
    //     setLoading(false);
    //     setchallenge(undefined);
    //     setTxn(undefined);
    //     setTxnwith(undefined);
    //     setKyc(undefined);
    //     setMerged(undefined);
    //     setPenalty(undefined);
    //     setBonus(res.data);
    //     setReferral(undefined);
    //     // console.log(res.data)
    //     $("table").dataTable();
    //   })
      // .catch((e) => {
      //   console.log(e);
      //   setLoading(false);
      // });


      try {
        const res =await apiRequest( `admin/bonus_history_admin/user/${user.id}`,"GET",null,headers);
        setLoading(false);
        setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);
        setKyc(undefined);
        setMerged(undefined);
        setPenalty(undefined);
        setBonus(res.data);
        setReferral(undefined);
        // console.log(res.data)
        $("table").dataTable();
    
      } catch (error) {
        // console.log(e);
        setLoading(false);
      } finally {
        // setLoading(false)
      }


  };
  const penaltyHis = async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // await axios
    //   .get(baseUrl + `admin/penalty_history_admin/user/${user.id}`, { headers })
    //   .then((res) => {
    //     setLoading(false);
    //     setchallenge(undefined);
    //     setTxn(undefined);
    //     setTxnwith(undefined);
    //     setKyc(undefined);
    //     setMerged(undefined);
    //     setPenalty(res.data);
    //     setBonus(undefined);
    //     setReferral(undefined);
    //     // console.log(res.data)
    //     $("table").dataTable();
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setLoading(false);
    //   });


      try {
        const res =await apiRequest(  `admin/penalty_history_admin/user/${user.id}`,"GET",null,headers);
        setLoading(false);
        setchallenge(undefined);
        setTxn(undefined);
        setTxnwith(undefined);
        setKyc(undefined);
        setMerged(undefined);
        setPenalty(res.data);
        setBonus(undefined);
        setReferral(undefined);
        // console.log(res.data)
        $("table").dataTable();
    
      } catch (error) {
        // console.log(e);
        setLoading(false);
      } finally {
        // setLoading(false)
      }

  };

  const getKyc =async () => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // axios.get(baseUrl + `admin/user/kyc/${path}`, { headers }).then((res) => {
    //   setLoading(false);
    //   setTxn(undefined);
    //   setTxnwith(undefined);
    //   setReferral(undefined);
    //   setBonus(undefined);
    //   setPenalty(undefined);
    //   setchallenge(undefined);
    //   setKyc(res.data);
    //   setMerged(undefined);
    //   // console.log(res.data);
    //   $("table").dataTable();
    //   imageViewer();
    // });

  
  try {
    const res =await apiRequest(   `admin/user/kyc/${path}`,"GET",null,headers);
    setLoading(false);
    setTxn(undefined);
    setTxnwith(undefined);
    setReferral(undefined);
    setBonus(undefined);
    setPenalty(undefined);
    setchallenge(undefined);
    setKyc(res.data);
    setMerged(undefined);
    // console.log(res.data);
    $("table").dataTable();
    imageViewer();

  } catch (error) {
    // console.log(error.message);
  } finally {
    // setLoading(false)
  }
};

  const all_history = () => {
    navigate.push(`/user/allhistory/${path}`);
  };

  function imageViewer() {
    let imgs = document.getElementsByClassName("img"),
      out = document.getElementsByClassName("img-out")[0];
    for (let i = 0; i < imgs.length; i++) {
      if (!imgs[i].classList.contains("el")) {
        imgs[i].classList.add("el");
        imgs[i].addEventListener("click", lightImage);
        function lightImage() {
          let container = document.getElementsByClassName("img-panel")[i];
          container.classList.toggle("img-panel__selct");
        }

        imgs[i].addEventListener("click", openImage);
        function openImage() {
          let imgElement = document.createElement("img"),
            imgWrapper = document.createElement("div"),
            imgClose = document.createElement("div"),
            container = document.getElementsByClassName("img-panel")[i];
          container.classList.add("img-panel__selct");
          imgElement.setAttribute("class", "image__selected");
          imgElement.src = imgs[i].src;
          imgWrapper.setAttribute("class", "img-wrapper");
          imgClose.setAttribute("class", "img-close");
          imgWrapper.appendChild(imgElement);
          imgWrapper.appendChild(imgClose);

          setTimeout(function () {
            imgWrapper.classList.add("img-wrapper__initial");
            imgElement.classList.add("img-selected-initial");
          }, 50);

          out.appendChild(imgWrapper);
          imgClose.addEventListener("click", function () {
            container.classList.remove("img-panel__selct");
            out.removeChild(imgWrapper);
          });
        }
      }
    }
  }
  const update = async(Id) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
  
      try {
        const res = await apiRequest(  `aadharcard/${Id}`,"PATCH", { verified: "verified" },headers)
           setLoading(false);
        getUser();
        getKyc();
      } catch (error) {
        //  console.log(e);
      } finally {
        // setLoading(false)
      }
  };
  const handleDelete =async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    if (window.confirm("Are you sure you want to delete?")) {
      console.log("deleted");
    
      try {
        const res = await apiRequest(  `aadharcard/${Id}`,"DELETE",{},headers)
        getKyc();
        getUser();

      } catch (error) {
        //  console.log(e);
      } finally {
        // setLoading(false)
      }
    } 
    else {
      console.log("cancel");
    }
  };

  const updateMismatch =async (Id) => {
    setLoading(true);

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
   
    try {
      const res = await apiRequest(  `admin/admin_user/missmatch/clear/${Id}`,"PATCH",null,headers)
         setLoading(false);
        getUser();
        alert("Updated Successfully");
    } catch (error) {
      //  console.log(e);
    } finally {
      // setLoading(false)
    }
  };

  const updateHold =async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    try {
      const res = await apiRequest(  `admin/admin_user/Hold/clear/${Id}`,"PATCH",null,headers)
        getUser();
        alert("Updated Successfully");
    } catch (error) {
      //  console.log(e);
    } finally {
      // setLoading(false)
    }
  };

  const checkfailedpayout = (txn_id, referenceId) => {
    setLoading(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    axios
      .post(
        baseUrl + `payout/response/api`,
        { txn_id, referenceId },
        { headers }
      )
      .then((res) => {
        setLoading(false);
        const icon = res.data.status == "SUCCESS" ? "success" : "danger";
        const title =
          res.data.status == "SUCCESS"
            ? "Withdraw successfully"
            : "Transaction Proccessing or Failed";
        getUser();
        withdrawalHis();
        alert(title);
      })
      .catch((e) => {
        setLoading(false);
        if (e.response.status == 401) {
          localStorage.removeItem("token");
          localStorage.removeItem("token");
          window.location.reload();
        }
      });
  };

  const deletedata =async (Id) => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    // axios
    //   .patch(baseUrl + `aadharcard/${Id}`, { verified: "reject" }, { headers })
    //   .then((res) => {
    //     getUser();
    //     getKyc();
    //   });
    try {
      const res = await apiRequest(  `aadharcard/${Id}`,"PATCH",{ verified: "reject" },headers)
          getUser();
        getKyc();
    } catch (error) {
    } finally {
      // setLoading(false)
    }
  };

  async function commonApi() {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    const [result1, result2, result3] = await Promise.all([
      axios.get(baseUrl + `get_challange/user/${path}`, { headers }),
      axios.get(baseUrl + `admin/txn_history_admin/user/${path}`, { headers }),
      axios.get(baseUrl + `admin/txnwith_history_user/admin/${path}`, { headers }),
    ]);
    setTxn(undefined);
    setTxnwith(undefined);
    setReferral(undefined);
    setBonus(undefined);
    setPenalty(undefined);
    setchallenge(undefined);

    setKyc(undefined);
    const data1 =
      result1.data &&
      result1.data.map((data) => {
        return {
          ID: data._id,
          amount: data.Game_Ammount,
          status: data.Status,
          date: dateFormat(data.updatedAt).split(",")[0],
          Win_loose_amount: data.Winner
            ? user?._id == data.Winner?._id
              ? "+" + data.winnAmount
              : "-" + data.Game_Ammount
            : user?._id == data.Created_by?._id
            ? data.winnAmount
            : "-" + data.winnAmount,
          closing_balance: data.Winner
            ? user?._id == data.Winner?._id
              ? data.Winner_closingbalance
              : data.Loser_closingbalance
            : user?._id == data.Created_by?._id
            ? data.Loser_closingbalance
            : data.Winner_closingbalance,
        };
      });
    const data2 =
      result2.data &&
      result2.data.map((data) => {
        return {
          ID: data._id,
          amount: data.amount,
          status: data.status,
          date: dateFormat(data.updatedAt).split(",")[0],
          Req_type: data.Req_type,
          closing_balance: data.closing_balance,
          Win_loose_amount: 0,
        };
      });
    const data3 =
      result3.data &&
      result3.data.map((data) => {
        return {
          ID: data._id,
          amount: data.amount,
          status: data.status,
          date: dateFormat(data.updatedAt).split(",")[0],
          Req_type: data.Req_type,
          closing_balance: data.closing_balance,
          Win_loose_amount: 0,
        };
      });
    const merge = data1.concat(data2, data3);
    setMerged(merge);
    $("table").dataTable();
  }

  const Referal = () => {
    const access_token = localStorage.getItem('token');
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };
    Swal.fire({
      title: "Enter Referral code",
      inputValue: user.referral,
      input: "number",
      inputAttributes: {
        autocapitalize: "off",
      },
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      preConfirm: async (login) => {

        try {
          const res = await apiRequest(`admin/user_update_refferal/${login ? login : "referral"}/${path}`, "GET", null, headers)
          if (res.data) {
            if (res.data) {
              Swal.fire({
                title: `${res.data?.msg}`,
              });
            }
            getUser();
            // return res.json();
          }
        } catch (e) {
          Swal.showValidationMessage(`Request failed: ${e.data?.msg}`);
        }
        finally {
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    })
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // demo table

  // view Refferal History
  function RefferalUser(id) {
    navigate.push(`/user/view_user/${id}`)
    handleClose()
    window.location.reload();
  }

  useEffect(() => {
    getUser();
    Allchallenge();
    getKyc();
  }, []);

  useEffect(() => {
    setMerged(null);
  }, []);

  // valid email
  function isValidEmail(email) {
    // Regular expression to match a valid email address
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  return loading ? (
    <>
      <div className="App">
        <div className="item dashboaed_loader">
          <Loader
            type="bubble-ping"
            bgColor={"#fff"}
            title={"Loading Please Wait"}
            color={"#FFFFFF"}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <>
      {Boolean(user) && (
        <>
          <div className="img-out"></div>
          <div className="row mt-5">
            <div className="col-lg-6 mb-4">
              <div className="card shadow-lg h-100 table_bg">
                <div className="card-header dashboard_heading">
                  User Details
                </div>
                <ul className="list-group list-group-flush">
                  {user && user.avatar && (
                    <li className="list-group-item img-panel">
                      Profile Pic :
                      <img
                        className="img"
                        src={baseUrl + `/${user.avatar}`}
                        alt="Profile"
                        style={{
                          borderRadius: "5px",
                          width: "4rem",
                          height: "4rem",
                        }}
                      />{" "}
                    </li>
                  )}
                  <li className="list-group-item">Name : {user.Name}</li>

                  <li className="list-group-item">
                    verified :{" "}
                    <span
                      className={`badge badge-pill ${
                        user.verified == "verified"
                          ? "badge-success"
                          : "badge-danger"
                      }`}
                    >
                      {user.verified}
                    </span>
                  </li>
                  {admindata?.user?.usertype == "Admin" ||
                  admindata?.user?.updateLegalData === true ? (
                                           <a
      href={`https://wa.me/91${user.Phone}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: 'none', color: 'inherit' }}
    >

      <li className="list-group-item text-green">Phone : {user.Phone}</li>
    </a>
                  ) : (
                    <li className="list-group-item">
                      {" "}
                      Phone :{" "}
                      {`${"********" + user.Phone.toString().slice(-2)}`}
                    </li>
                  )}
                 <li className="list-group-item">
  Email : {isValidEmail(user.Email) ? user.Email : ' '}
</li>
                  <li className="list-group-item">
                    Wallet balance : {user.Wallet_balance}
                  </li>
                  <li className="list-group-item">
                    Withdrawal Amount balance : {user.withdrawAmount}
                  </li>
                  <li className="list-group-item">
                    Withdrawal Hold balance : {user.withdraw_holdbalance}
                    <div className="col" style={{ color: "#8c8c8c" }}>
                      Note: If hold balance not 0 user can't make new Withdrawal
                      request
                    </div>
                  </li>
                  <li className="list-group-item">
                    Referral balance : {user.referral_wallet}
                  </li>
                  <li className="list-group-item">
                    Referral count : {referCount && referCount}
                  </li>
                  <li className="list-group-item">
                    Referral earning : {user.referral_earning}
                  </li>
                  <li className="list-group-item">
                    total Deposit : {user.totalDeposit}
                  </li>
                  <li className="list-group-item">
                    total Withdrawal : {user.totalWithdrawl}
                  </li>
                  <li className="list-group-item">
                    total Bonus : {user.totalBonus}
                  </li>
                  <li className="list-group-item">
                    total Penalty : {user.totalPenalty}
                  </li>
                  <li className="list-group-item">
                    hold balance : {HoldBalance}
                  </li>
                  <li className="list-group-item">
                    Won amount : {user.wonAmount}
                  </li>
                  <li className="list-group-item">
                    Lose amount : {user.loseAmount}
                  </li>
                  <li className="list-group-item">
                    Calculated wallet balance :{" "}
                    {user.wonAmount -
                      user.loseAmount +
                      user.totalDeposit +
                      user.referral_earning +
                      user.totalBonus -
                      (user.totalWithdrawl +
                        user.referral_wallet +
                        user.withdraw_holdbalance +
                        user.hold_balance +
                        user.totalPenalty)}
                  </li>
                  <li className="list-group-item">
                    Mismatch wallet balance : {mismatchValue}
                  </li>
                  <li className="list-group-item">
                    Referral code : {user.referral_code}
                    <span>
                      {" "}
                      <RemoveRedEyeIcon onClick={handleShow} />{" "}
                    </span>
                  </li>
                  {/* {(props.updateLegalData)  && ( */}
                  <li className="list-group-item">
                    {/* Referral by : {user.referral} */}
                    {console.log(user1,'user1?.Permissions')}
                     Referral by : {user.referral}  {user1?.user_type == 'Admin' ? <BiEditAlt onClick={Referal} />  : ""}
                  </li>
                  {/* )} */}

                  <li className="list-group-item">
                    Account created at :{" "}
                    {dateFormat(user.createdAt).split(",")[0]}
                  </li>
                  <li className="list-group-item">
                    Account updated at :{" "}
                    {dateFormat(user.updatedAt).split(",")[0]}
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6 mb-4">
              <div className="card shadow-lg h-100 table_bg">
                <div className="card-header dashboard_heading">
                  Bank Details
                </div>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    Account holder name : {user.holder_name}
                  </li>
                  <li className="list-group-item">
                    IFSC code : {user.ifsc_code}
                  </li>
                  <li className="list-group-item">
                    Account number : {user.account_number}
                  </li>
                  <li className="list-group-item">UPI ID : {user.upi_id}</li>
                </ul>
                <ul className="list-group list-group-flush">
                  <li className="list-group-item">
                    Mismatch:{" "}
                    <button
                      onClick={() => updateMismatch(user._id)}
                      className="btn btn-success"
                    >
                      CLEAR ({mismatchValue})
                    </button>
                  </li>
                  <li className="list-group-item">
                    Hold :{" "}
                    <button
                      onClick={() => updateHold(user._id)}
                      className="btn btn-success"
                    >
                      CLEAR ({HoldBalance})
                    </button>{" "}
                  </li>
                  <li className="list-group-item">
                    Status :
                    {user.user_type == "Block" ? (
                      <>
                        <span style={{ color: "red" }}>Block</span>
                        <br></br> <span>Reason: {user.lastmsg}</span>
                      </>
                    ) : (
                      <span style={{ color: "green" }}> Active </span>
                    )}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row ">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body table_bg">
                  <button
                    className={
                      Boolean(challenge)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={Allchallenge}
                  >
                    Game History
                  </button>

                  <button
                    className={
                      Boolean(txn)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={transactionHis}
                  >
                    Deposit History
                  </button>
                  <button
                    className={
                      Boolean(txnwith)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={withdrawalHis}
                  >
                    withdrawal History
                  </button>
                  <button
                    className={
                      Boolean(referral)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={referralHis}
                  >
                    Referral History
                  </button>
                  <button
                    className={
                      Boolean(bonus)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={bonusHis}
                  >
                    Bonus History
                  </button>
                  <button
                    className={
                      Boolean(penalty)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={penaltyHis}
                  >
                    Penalty History
                  </button>
                  <button
                    className={
                      Boolean(kyc)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={getKyc}
                  >
                    KYC
                  </button>
                  {/* <button
                    className={
                      Boolean(merged)
                        ? `btn btn-success mb-3 mr-2`
                        : `btn btn-info mb-3 mr-2`
                    }
                    onClick={commonApi}
                  >
                    Merged
                  </button> */}
                  <button
                    className="btn btn-primary mb-3 mr-2"
                    onClick={all_history}
                  >
                    All Histoty
                  </button>
                  {Boolean(challenge) && (
                    <div className="table-responsive">
                      <table className="table table_bg">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Creator</th>
                            <th> Accepter</th>
                            <th> Amount </th>
                            <th> Win/Lose Amt </th>
                            <th> closing balance</th>
                            <th> Status </th>
                            <th> Game Type </th>
                            <th> Winner </th>
                            <th> Date </th>
                            <th> Action </th>
                          </tr>
                        </thead>

                        <tbody>
                          {challenge &&
                            challenge?.map((game, key) => (
                              <tr key={key}>
                                <td>{key + 1}</td>
                                <td>{game?._id ? game?._id : null}</td>
                                <td>
                                  <span className="pl-2 ">
                                    {game.Created_by
                                      ? game.Created_by.Name
                                      : null}
                                  </span>
                                </td>

                                <td>
                                  <span className="pl-2">
                                    {game.Accepetd_By
                                      ? game.Accepetd_By.Name
                                      : null}
                                  </span>
                                </td>
                                <td>{game.Game_Ammount}</td>

                                <td>
                                  {game.Winner
                                    ? user?._id == game.Winner?._id
                                      ? "+" + game.winnAmount
                                      : "-" + game.Game_Ammount
                                    : user?._id == game.Created_by?._id
                                    ? game.winnAmount
                                    : "-" + game.winnAmount}
                                </td>

                                <td>
                                  {game.Winner
                                    ? user?._id == game.Winner?._id
                                      ? game.Winner_closingbalance
                                      : game.Loser_closingbalance
                                    : user?._id == game.Created_by?._id
                                    ? game.Loser_closingbalance
                                    : game.Winner_closingbalance}
                                </td>
                                <td className="text-primary font-weight-bold">
                                  {game.Status}
                                </td>
                                <td>{game.Game_type}</td>
                                <td>{game.Winner ? game.Winner.Name : null}</td>

                                <td>
                                  {moment(game.updatedAt).format(
                                    "MMMM Do YYYY, h:mm:ss a"
                                  )}
                                </td>

                                <td>
                                  <Link
                                    type="button"
                                    className="btn btn-primary mx-1"
                                    to={`/view/${game._id}`}
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {Boolean(txn) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Status </th>
                            <th> Payment gatway </th>
                            <th>created At</th>
                            <th>updated At</th>
                          </tr>
                        </thead>
                        <tbody>
                          {txn.map((data, key) => (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{data._id}</td>

                              <td>{data.amount}</td>
                              <td> {data.closing_balance}</td>
                              <td className="font-weight-bold text-success">
                                {data.status}
                              </td>
                              <td>
                                {" "}
                                {data.payment_gatway ? data.payment_gatway : ""}
                              </td>
                              <td>
                                {moment(data.createdAt).format(
                                  "MMMM D [at] h:mm A"
                                )}
                              </td>
                              <td>
                                {moment(data.updatedAt).format(
                                  "MMMM D [at] h:mm A"
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(txnwith) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>

                            <th> type</th>
                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Status </th>
                            <th> Action </th>
                            <th> created At </th>
                            <th> updated At </th>
                          </tr>
                        </thead>
                        <tbody>
                          {txnwith &&
                            txnwith.map((data, key) => (
                              <tr>
                                <td>{key + 1}</td>
                                <td>{data._id}</td>

                                <td>
                                  <span className="pl-2">
                                    {data.Withdraw_type}
                                  </span>
                                </td>
                                <td>{data.amount}</td>
                                <td> {data.closing_balance}</td>
                                <td className="font-weight-bold text-success">
                                  {data.status}
                                </td>
                                <td>
                                  {
                                    //&& data.status != 'FAILED'
                                    data.status != "SUCCESS" &&
                                    data.amount == user.withdraw_holdbalance ? (
                                      <button
                                        className="btn btn-danger"
                                        onClick={() =>
                                          checkfailedpayout(
                                            data._id,
                                            data.referenceId
                                          )
                                        }
                                      >
                                        Check {data.payment_gatway}
                                      </button>
                                    ) : (
                                      "Checked"
                                    )
                                  }
                                </td>
                                <td>
                                  {moment(data.createdAt).format(
                                    "MMMM D [at] h:mm A"
                                  )}
                                </td>
                                <td>
                                  {moment(data.updatedAt).format(
                                    "MMMM D [at] h:mm A"
                                  )}{" "}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(referral) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Earned by</th>
                            <th> Amount </th>
                            <th> Closing balance</th>
                            <th> Date </th>
                          </tr>
                        </thead>
                        <tbody>
                          {referral?.map((data, key) => (
                            <tr key={key}>
                              <td>{key + 1}</td>
                              <td>{data._id}</td>
                              <td>{data.earned_from.Name}</td>
                              <td>{data.amount}</td>
                              <td>{data.closing_balance}</td>
                              {/* <td>{dateFormat(data.updatedAt).split(',')[0]} </td> */}
                              <td>
                                {moment(data.updatedAt).format(
                                  "MMMM Do YYYY, h:mm:ss a"
                                )}{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(kyc) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>

                            <th>Doc name</th>
                            <th> Aadhar no</th>
                            <th> Address</th>

                            <th>DOB</th>
                            <th> Document-Front</th>
                            <th> Document-Back</th>
                            <th> status </th>
                            <th>Date</th>
                            <th> Approve or Reject </th>
                            {/* <th> View </th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {kyc &&
                            kyc.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item._id}</td>

                                <td>{item.Name}</td>

                                <td>{item.Number}</td>
                                <td>{item.Address?item.Address.replace(/<br>/g, '').slice(0, 150):''}</td>
                                <td>{item.DOB}</td>
                                <td>
                                  <div className="img-panel">
                                    <img
                                      className="img"
                                      src={baseUrl + `/${item.front}`}
                                      onError={(e) => {
                                        e.target.onerror = null; 
                                        e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
                                      }}
                                      alt="kyc"
                                      style={{
                                        borderRadius: "5px",
                                        width: "4rem",
                                        height: "4rem",
                                      }}
                                      id={`kyc${index}`}
                                    />
                                  </div>
                                </td>
                                <td>
                                  <div className="img-panel">
                                    <img
                                      className="img"
                                      src={baseUrl + `/${item.back}`}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/No-Image-Placeholder.svg/1200px-No-Image-Placeholder.svg.png';
                                      }}
                                      alt="kyc"
                                      style={{
                                        borderRadius: "5px",
                                        width: "4rem",
                                        height: "4rem",
                                      }}
                                      id={`kyc${index}`}
                                    />
                                  </div>
                                </td>

                                <td>
                                  <span
                                    className={
                                      item.verified === "reject"
                                        ? "btn btn-danger"
                                        : "btn btn-success"
                                    }
                                  >
                                    {item.verified}
                                  </span>{" "}
                                </td>
                                <td>
                                  {/* {dateFormat(item.updatedAt).split(",")[0]}{" "} */}
                                  <td>
                                    {moment(item?.updatedAt).format(
                                      "MMMM Do YYYY, h:mm:ss a"
                                    )}
                                  </td>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-success mr-1"
                                    disabled={
                                      item.verified === "verified"
                                        ? true
                                        : false
                                    }
                                    onClick={() => update(item._id)}
                                  >
                                    Approve
                                  </button>
                                  <button
                                    className="btn btn-danger mr-1"
                                    disabled={
                                      item.verified === "verified"
                                        ? false
                                        : false
                                    }
                                    onClick={() => deletedata(item._id)}
                                  >
                                    Reject
                                  </button>
                                  <button
                                    className="btn btn-danger"
                                    onClick={() => handleDelete(item._id)}
                                  >
                                    Force delete
                                  </button>
                                </td>
                                {/* <td><Link to="/user/view" className="btn btn-primary">View</Link></td> */}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(merged) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Amount </th>
                            <th>Win/Loose Amt</th>
                            <th>Closing Balance</th>
                            <th> Status</th>
                            <th> Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {merged.map((data, key) => {
                            // console.log(data.Game_Amount)
                            return (
                              <tr
                                key={key}
                                style={{
                                  color:
                                    data.Req_type == "deposit"
                                      ? "green"
                                      : data.Req_type == "withdraw"
                                      ? "		#ff7f50"
                                      : "black",
                                }}
                              >
                                <td>{key + 1}</td>
                                <td>{data.ID}</td>
                                <td>{data.amount}</td>
                                <td>{data.Win_loose_amount}</td>
                                <td>{data.closing_balance}</td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    color:
                                      data.status == "SUCCESS"
                                        ? "seagreen"
                                        : data.status == "completed"
                                        ? "royalblue"
                                        : data.status == "cancelled"
                                        ? "salmon"
                                        : data.status == "FAILED"
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {data.status}
                                  {data.status == "PAID" ? (
                                    <span>&#9989;</span>
                                  ) : data.status == "FAILED" ? (
                                    <span>&#10060;</span>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                {/* <td>{data.date} </td> */}
                                <td>
                                  {moment(data.updatedAt).format(
                                    "MMMM Do YYYY, h:mm:ss a"
                                  )}{" "}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(bonus) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Amount </th>
                            <th>Closing Balance</th>
                            <th>Reason</th>
                            <th> Status</th>
                            <th> Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {bonus.map((data, key) => {
                            // console.log(data.Game_Amount)
                            return (
                              <tr
                                key={key}
                                style={{
                                  color:
                                    data.Req_type == "deposit"
                                      ? "green"
                                      : data.Req_type == "withdraw"
                                      ? "		#ff7f50"
                                      : "black",
                                }}
                              >
                                <td>{key + 1}</td>
                                <td>{data._id}</td>
                                <td>{data.amount}</td>
                                <td>{data.closing_balance}</td>
                                <td>{data.txn_msg}</td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    color:
                                      data.status == "SUCCESS"
                                        ? "seagreen"
                                        : data.status == "completed"
                                        ? "royalblue"
                                        : data.status == "cancelled"
                                        ? "salmon"
                                        : data.status == "FAILED"
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {data.status}
                                  {data.status == "PAID" ? (
                                    <span>&#9989;</span>
                                  ) : data.status == "FAILED" ? (
                                    <span>&#10060;</span>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                {/* <td>{data.date} </td> */}
                                <td>
                                  {moment(data.updatedAt).format(
                                    "MMMM Do YYYY, h:mm:ss a"
                                  )}{" "}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {Boolean(penalty) && (
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th> ID</th>
                            <th> Amount </th>
                            <th>Closing Balance</th>
                            <th>Reason</th>
                            <th> Status</th>
                            <th> Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {penalty.map((data, key) => {
                            // console.log(data.Game_Amount)
                            return (
                              <tr
                                key={key}
                                style={{
                                  color:
                                    data.Req_type == "deposit"
                                      ? "green"
                                      : data.Req_type == "withdraw"
                                      ? "		#ff7f50"
                                      : "black",
                                }}
                              >
                                <td>{key + 1}</td>
                                <td>{data._id}</td>
                                <td>{data.amount}</td>
                                <td>{data.closing_balance}</td>
                                <td>{data.txn_msg}</td>
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    color:
                                      data.status == "SUCCESS"
                                        ? "seagreen"
                                        : data.status == "completed"
                                        ? "royalblue"
                                        : data.status == "cancelled"
                                        ? "salmon"
                                        : data.status == "FAILED"
                                        ? "red"
                                        : "black",
                                  }}
                                >
                                  {data.status}
                                  {data.status == "PAID" ? (
                                    <span>&#9989;</span>
                                  ) : data.status == "FAILED" ? (
                                    <span>&#10060;</span>
                                  ) : (
                                    ""
                                  )}
                                </td>
                                {/* <td>{data.date} </td> */}
                                <td>
                                  {moment(data.updatedAt).format(
                                    "MMMM Do YYYY, h:mm:ss a"
                                  )}{" "}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Refferal History</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row mt-5">
            <div className="col-12 grid-margin">
              <div className="card">
                <div className="card-body text-light table_bg">
                  <h4 className="dashboard_heading">Refferal History</h4>
                  <select
                    className="form-control col-sm-1 m-1 bg-dark text-light"
                    id="pagelimit"
                    name="pagelimit"
                    onChange={setpageLimit}
                  >
                    <option value="10">Set limit</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                  </select>
                  <div className="table-responsive">
                    <table className="table text-light">
                      <thead>
                        <tr>
                          <th>#</th>

                          <th> Name</th>
                          <th> Number</th>
                        </tr>
                      </thead>

                      <tbody>
                        {user &&
                          user?.referral_user?.map((data, key) => (
                            <tr key={user._id}>
                              <td>{key + 1}</td>
                              <td>
                                <span
                                  className="badge badge-pill"
                                  style={{
                                    background: "green",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => RefferalUser(data.id)}
                                >
                                  {data.Name}
                                </span>
                              </td>
                              {/* <td>{`${
                                "********" + data.Phone.toString().slice(-4)
                              }`}</td> */}
                                {admindata?.user?.usertype == 'Admin' ||
                          admindata?.user?.updateLegalData === true ? (
                            <td className='text-success'>{data.Phone}</td>
                          ) : (
                            <td className='text-success'>{`${
                              '********' + data.Phone.toString().slice(-2)
                            }`}</td>
                          )}
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="mt-4">
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={numberOfPages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
